import { articleRentFilters } from '@/app/settings/modules/invoicing/articles/rent/filters';
import { Badge } from '@/components/ui/badge';
import { ArticleConfig, type Article } from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';
import { toMoneyString } from '@/lib/utils';

export const ArticleItem: RelationFieldProps<Article> = {
  nested: ['category'],
  filters: articleRentFilters,
  renderItem: (item) => ({
    title: item?.name,
    badge: (
      <Badge variant={item?.considerBaseRent ? 'green' : 'gray'}>
        {item?.considerBaseRent ? 'Bashyra' : 'Ej bashyra'}
      </Badge>
    ),
    descriptionItems: (
      <div className='flex w-full items-center'>
        <span className='font-medium'>
          {item?.ignoreDynamiclyCalculatedVat
            ? `${item?.vat}% moms`
            : 'Dynamisk moms'}
        </span>
        <Dot />
        <span>
          {
            ArticleConfig?.fields.invoiceTypes.choices?.find(
              (opt) => opt.v === item?.invoiceTypes
            )?.d
          }
        </span>
        {item.unit && (
          <>
            <Dot />
            <span>{item.unit}</span>
          </>
        )}
        {item.invoiceTypes === 1 && (
          <>
            <Dot />
            <span>{toMoneyString(item.proposedUnitPrice)}</span>
          </>
        )}
      </div>
    ),
  }),
};
